var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHowSetupIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "152px",
    height: "168px",
    viewBox: "0 0 152 168",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "How setup icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 143.769231 0 143.769231 143.767074 0 143.767074"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "How-setup-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(4.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1523508,68.3744862 C81.4718585,71.01984 78.2514277,73.3201477 78.2514277,77.00064 C78.2514277,78.9631015 79.0565354,80.6883323 79.9766585,81.6084554 L64.6724308,85.5189785 C62.4871385,82.8736246 61.1069538,79.3081477 61.1069538,74.9375631 C61.1069538,67.0015015 66.6276923,63.0837785 70.8904431,60.2083938 C73.7658277,58.2531323 76.0661354,56.6429169 76.0661354,54.2204123 C76.0661354,51.6972554 74.2258892,49.7348123 69.2802277,49.7348123 C64.9024615,49.7348123 60.4168615,52.0423015 57.1964308,55.7156123 L46.1477723,43.06392 C52.4808,35.9257662 62.0270769,32.2524738 71.46552,32.2524738 C86.6475508,32.2524738 96.0860123,39.6134585 96.0860123,50.6549354 C96.0860123,60.2083938 90.2130277,64.5861785 85.1523508,68.3744862 L85.1523508,68.3744862 Z M71.6883692,111.519637 C65.8225846,111.519637 60.8769231,106.573975 60.8769231,100.708191 C60.8769231,94.8424062 65.8225846,89.8895631 71.6883692,89.8895631 C77.5613354,89.8895631 82.5069969,94.8424062 82.5069969,100.708191 C82.5069969,106.573975 77.5613354,111.519637 71.6883692,111.519637 L71.6883692,111.519637 Z M131.970812,111.296788 C139.410868,99.9749723 143.767071,86.4462831 143.767071,71.8824554 C143.767071,32.1805846 111.584326,-0.00216 71.8824554,-0.00216 C32.1805846,-0.00216 -0.00215653846,32.1805846 -0.00215653846,71.8824554 C-0.00215653846,111.584326 32.1805846,143.767074 71.8824554,143.767074 L136.571428,143.767074 C141.912443,143.767074 145.391668,138.145697 143.005089,133.365371 L131.970812,111.296788 Z",
    id: "Fill-1",
    fill: "#5F1486",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowSetupIcon);
export default __webpack_public_path__ + "static/media/How-setup-icon.4f804e85bc897c5801a1da0f490c3f53.svg";
export { ForwardRef as ReactComponent };